import React, { useEffect } from 'react';
import { useGetStatusesQuery } from '../apis/apiApplication';
import { useAppDispatch } from '../store';
import { addToast } from '@ydistri/utils';
import { useTemplateOrCalculationWithValue } from '../hooks/useTemplateOrCalculationWithValue';

const ApplicationStatusController: React.FC = () => {
  const templateOrCalculation = useTemplateOrCalculationWithValue('Template');
  const { data: statuses } = useGetStatusesQuery(templateOrCalculation.value);
  const dispatch = useAppDispatch();

  const refresh = statuses?.refresh;

  useEffect(() => {
    if (!refresh) return;
    dispatch(addToast({ message: `Application reopened. Refreshing...` }));

    const id = setTimeout(() => {
      if (typeof window !== 'undefined') window.location.reload();
    }, 2500);

    return () => clearTimeout(id);
  }, [dispatch, refresh]);

  return null;
};

export default ApplicationStatusController;
